import scrollTo from '../helpers/scrollTo';

export default () => {
	const links = document.querySelectorAll('.js-scroll-top');

	links.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			scrollTo(0, 0, 1500);
		});
	});
}

